/** One option per label: reasons sharing a name (e.g. a `_BY_WHOLESALE` variant) filter together. */
export const groupTerminationReasonOptions = (
  reasons: ReadonlyArray<string>,
  label: (reason: string) => string,
): Array<{ value: string; label: string; values: string[] }> => {
  const byLabel = new Map<string, { value: string; label: string; values: string[] }>();
  for (const reason of reasons) {
    const name = label(reason);
    const existing = byLabel.get(name);
    if (existing) {
      existing.values.push(reason);
    } else {
      byLabel.set(name, { value: reason, label: name, values: [reason] });
    }
  }
  return Array.from(byLabel.values());
};
